import { Stack } from "@certa/catalyst/layouts/Stack";
import { useToolbar } from "./Toolbar.hooks";
import { Download } from "@certa/icons/components/Download";
import {
  Ellipsis,
  Typography,
  TypographyColors,
  TypographyVariants
} from "@certa/catalyst/components/Typography";
import {
  Button,
  ButtonColors,
  ButtonTypes
} from "@certa/catalyst/components/Button";
import type { ToolbarProps } from "./Toolbar.types";
import { css } from "emotion";
import { useIntl } from "react-intl";
import { ScalingTool } from "../Scaling/ScalingTool";
import { FitWidthHeightToggle } from "../FitWidthHeightToggle";

export const Toolbar = ({
  pageScale,
  pdfContainerRef,
  pdfContainerParentRef,
  pageDimensions,
  fileName,
  totalNoOfPages,
  onDownload,
  handleScaleChange,
  initialPageSize
}: ToolbarProps) => {
  const intl = useIntl();
  const { currentPage } = useToolbar({
    pageDimensions,
    pdfContainerRef
  });
  return (
    <Stack
      direction="horizontal"
      align="center"
      justify="space-between"
      width="100%"
      padding="8 16"
      dangerouslySetClassName={toolbarContainer}
    >
      {/* File Name */}
      <div style={{ maxWidth: "16rem" }}>
        <Typography
          color={TypographyColors.NEUTRAL_100}
          variant={TypographyVariants.BODY_BOLD}
          as="span"
        >
          <Ellipsis>{fileName}</Ellipsis>
        </Typography>
      </div>

      {/* toolbar controls */}
      <Stack direction="horizontal" align="center" gap="16">
        <div>
          <Typography color={TypographyColors.NEUTRAL_100}>
            Page {currentPage} / {totalNoOfPages}
          </Typography>
        </div>
        <ScalingTool initialScale={pageScale} setScale={handleScaleChange} />
        <FitWidthHeightToggle
          pdfContainerParentRef={pdfContainerParentRef}
          handleScaleChange={handleScaleChange}
          initialPageSize={initialPageSize}
        />
      </Stack>

      {/* Actions */}
      <Stack direction="horizontal" align="center" gap="16">
        {onDownload && (
          <Button
            type={ButtonTypes.ICON}
            onClick={onDownload}
            aria-label={intl.formatMessage({
              id: "common.download",
              defaultMessage: "Download"
            })}
            color={ButtonColors.BRAND}
          >
            <Download />
          </Button>
        )}
      </Stack>
    </Stack>
  );
};

const toolbarContainer = css({
  backgroundColor: "rgba(40, 40, 40)",
  position: "absolute",
  left: 0,
  top: 0,
  boxShadow: "0 4px 10px 2px rgb(73, 75, 78)",
  zIndex: 5
});
